import EmptyState from "@/components/EmptyState";
import CareerPlanSummaryCard from "./_CareerPlanSummaryCard";
import { getHubCareerGoalRows } from "./careerPlanHubSummaries";
import type { CareerPlanGoal } from "./careerPlanHistory";

export default function CurrentCareerGoalsCard({
  goal,
  loading,
  pgaId,
  hasArchivedCareerGoals = false
}: {
  goal: CareerPlanGoal | null;
  loading: boolean;
  pgaId?: string;
  /** True when inactive Intent versions exist (even if there is no active Intent). */
  hasArchivedCareerGoals?: boolean;
}) {
  const rows = getHubCareerGoalRows(goal);

  return (
    <CareerPlanSummaryCard
      title="Career Goals"
      testId="current-career-goals"
      updatedAt={goal?.updatedAt}
      loading={loading}
      pgaId={pgaId}
      viewAllTab="goals"
      showViewAll={!!goal}
      options={
        goal
          ? rows.map((row) => ({
              iconName: row.iconName,
              overline: row.label,
              headline: row.value,
              longContent: true
            }))
          : []
      }
    >
      {!goal ? (
        <div className="flex min-h-0 w-full flex-1 flex-col items-center justify-center">
          <EmptyState
            iconName="track_changes"
            title="No Career Goals"
            caption={
              hasArchivedCareerGoals
                ? "This person does not have active Career Goals."
                : "This person has not submitted Career Goals yet."
            }
          />
        </div>
      ) : null}
    </CareerPlanSummaryCard>
  );
}
